"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chain = void 0;
const chain = (arr) => ({
    arr,
    filterIf(cond, pred) {
        return (0, exports.chain)(cond ? arr.filter(pred) : arr);
    },
    map(fn) {
        return (0, exports.chain)(arr.map(fn));
    },
    value() {
        return arr;
    },
    shallowCopy() {
        return [...arr];
    },
});
exports.chain = chain;
//# sourceMappingURL=chain.js.map